module.exports = __webpack_public_path__ + "static/media/MyHealthNB-Logo.7bdbaec6.png";